<style>
  .docx-converter-page {
    --dx-primary: #5b21b6;
    --dx-primary-dark: #4c1d95;
    --dx-primary-soft: #f5f1fc;
    --dx-primary-tint: #ede9fe;
    --dx-primary-border: #c9b8f0;
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f3f2f7;
    overflow: hidden;
    box-sizing: border-box;
    padding: 24px;
  }

  .docx-converter-shell {
    display: flex;
    gap: 24px;
    width: 100%;
    max-width: 1400px;
    height: 100%;
  }

  .docx-panel {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 6px 24px rgba(17, 12, 46, 0.08);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 0;
  }

  .preview-col { flex: 1.4; }
  .upload-col { flex: 1; max-width: 420px; }

  .panel-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
    font-weight: 600;
    color: #2b2b33;
    font-size: 15px;
    flex-shrink: 0;
  }

  .panel-header i {
    color: var(--dx-primary);
    font-size: 20px;
  }

  .page-badge {
    margin-left: auto;
    background: var(--dx-primary-tint);
    color: var(--dx-primary);
    padding: 3px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
  }

  .preview-body {
    flex: 1;
    background: #f5f3ff;
    display: flex;
    min-height: 0;
  }

  .preview-frame {
    width: 100%;
    height: 100%;
    border: none;
  }

  .empty-state {
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    color: #9b98a6;
    text-align: center;
    padding: 20px;
  }

  .empty-state i {
    font-size: 52px;
    color: #cabdea;
  }

  .upload-body {
    flex: 1;
    padding: 24px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    min-height: 0;
  }

  .upload-dropzone {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border: 2px dashed var(--dx-primary-border);
    border-radius: 12px;
    padding: 36px 16px;
    cursor: pointer;
    color: var(--dx-primary);
    text-align: center;
    transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
  }

  .upload-dropzone:hover {
    background: var(--dx-primary-soft);
    border-color: var(--dx-primary);
    transform: translateY(-1px);
  }

  .upload-dropzone.is-disabled {
    pointer-events: none;
    opacity: 0.55;
  }

  .upload-dropzone i {
    font-size: 42px;
  }

  .dropzone-text {
    font-size: 14px;
    font-weight: 600;
    word-break: break-word;
  }

  .dropzone-hint {
    font-size: 12px;
    color: #8a86a0;
    font-weight: 400;
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }

  .action-row {
    display: flex;
    gap: 12px;
    margin-top: 20px;
  }

  .btn-app {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 14px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    border: 1.5px solid transparent;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
  }

  .btn-app i {
    font-size: 16px;
  }

  .btn-app:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: none !important;
  }

  .btn-primary {
    background: var(--dx-primary);
    color: #fff;
  }

  .btn-primary:hover:not(:disabled) {
    background: var(--dx-primary-dark);
    box-shadow: 0 6px 16px rgba(91, 33, 182, 0.35);
    transform: translateY(-1px);
  }

  .btn-outline {
    background: #fff;
    color: var(--dx-primary);
    border-color: var(--dx-primary);
  }

  .btn-outline:hover:not(:disabled) {
    background: var(--dx-primary);
    color: #fff;
    transform: translateY(-1px);
  }

  .loading-block {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 18px;
    background: var(--dx-primary-soft);
    border-radius: 10px;
  }

  .loading-spinner {
    font-size: 30px;
    color: var(--dx-primary);
  }

  .loading-text {
    font-size: 13px;
    color: #5b5870;
    text-align: center;
  }

  .progress-track {
    width: 100%;
    height: 8px;
    background: #e5defa;
    border-radius: 999px;
    overflow: hidden;
  }

  .progress-fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, var(--dx-primary), #8b5cf6, var(--dx-primary));
    background-size: 200% 100%;
    animation: dx-shimmer 1.2s linear infinite;
    transition: width 0.2s ease;
  }

  @keyframes dx-shimmer {
    0% { background-position: 0 0; }
    100% { background-position: -200% 0; }
  }

  .progress-percent {
    font-size: 12px;
    font-weight: 700;
    color: var(--dx-primary);
  }

  .alert-box {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    padding: 12px 14px;
    border-radius: 8px;
    margin-top: 16px;
    font-size: 13px;
    text-align: left;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
  }

  .alert-box i {
    font-size: 18px;
    margin-top: 1px;
    flex-shrink: 0;
  }

  .alert-danger {
    background: #fdecea;
    color: #b3261e;
  }

  .alert-warning {
    background: #fff8e1;
    color: #8a6d00;
  }

  .alert-info {
    background: var(--dx-primary-soft);
    color: var(--dx-primary-dark);
  }

  .alert-box > div {
    min-width: 0;
    flex: 1;
  }

  .alert-title {
    font-weight: 700;
    margin-bottom: 4px;
  }

  .alert-box ul {
    margin: 0;
    padding-left: 18px;
    max-height: 240px;
    overflow-y: auto;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .alert-box ul li {
    margin-bottom: 6px;
    line-height: 1.4;
  }

  .alert-box ul li:last-child {
    margin-bottom: 0;
  }

  .alert-collapsible {
    flex-direction: column;
    align-items: stretch;
    padding: 0;
    overflow: hidden;
  }

  .alert-collapsible-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    cursor: pointer;
    user-select: none;
  }

  .alert-collapsible-header .alert-title {
    margin-bottom: 0;
  }

  .alert-count-badge {
    background: rgba(138, 109, 0, 0.15);
    color: #8a6d00;
    font-size: 11px;
    font-weight: 700;
    padding: 1px 8px;
    border-radius: 999px;
  }

  .alert-chevron {
    margin-left: auto;
    font-size: 18px;
    transition: transform 0.2s ease;
  }

  .alert-chevron.is-open {
    transform: rotate(180deg);
  }

  .alert-collapsible ul {
    margin: 0;
    padding: 0 14px 12px 32px;
  }

  .engine-toggle {
    margin-left: auto;
    display: flex;
    gap: 6px;
    background: #f2f0f7;
    border-radius: 8px;
    padding: 3px;
  }

  .engine-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: transparent;
    color: #5b5870;
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;
  }

  .engine-btn:hover:not(:disabled) {
    color: var(--dx-primary);
  }

  .engine-btn.active {
    background: #fff;
    color: var(--dx-primary);
    box-shadow: 0 1px 3px rgba(17, 12, 46, 0.15);
  }

  .engine-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .engine-note {
    flex-shrink: 0;
    padding: 10px 20px;
    background: #fff8e1;
    color: #8a6d00;
    font-size: 12px;
    border-top: 1px solid #eee;
  }

  /* .docx-document / .docx-page-footer typography for the canvas content is injected at runtime
     (see updateEditableCanvasStyles) so the page-box look matches the downloaded HTML exactly. */

  .editable-canvas-wrap {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }

  .editable-canvas {
    outline: none;
    cursor: text;
  }

  .editable-canvas .docx-document {
    cursor: text;
  }

  .field-toolbar {
    margin-top: 20px;
    border-top: 1px solid #eee;
    padding-top: 16px;
  }

  .field-toolbar.is-disabled .field-chip {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .field-toolbar-title {
    font-size: 13px;
    font-weight: 700;
    color: #2b2b33;
    margin-bottom: 10px;
  }

  .field-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 12px;
    margin: 0 8px 8px 0;
    background: var(--dx-primary-soft);
    color: var(--dx-primary-dark);
    border: 1px solid var(--dx-primary-border);
    border-radius: 0.4rem;
    font-size: 12px;
    font-weight: 600;
    cursor: grab;
    user-select: none;
  }

  /* Same per-type colors as .tf-field-editor.tf-field-* in FIELD_CHIP_STYLES, so a sidebar chip
     already shows the color it will have once dropped. */
  .field-chip[data-field-type='text'] { background: #ebdeff; color: #5b21b6; border-color: #a079df; }
  .field-chip[data-field-type='number'] { background: #e8f5e9; color: #2e7d32; border-color: #a5d6a7; }
  .field-chip[data-field-type='date'] { background: #e3f2fd; color: #1565c0; border-color: #90caf9; }
  .field-chip[data-field-type='dropdown'] { background: #f3e5f5; color: #6a1b9a; border-color: #ce93d8; }
  .field-chip[data-field-type='checkbox'] { background: #e0f7fa; color: #00838f; border-color: #80deea; }
  .field-chip[data-field-type='signature'] { background: #fce4ec; color: #ad1457; border-color: #f48fb1; }
  .field-chip[data-field-type='radio'] { background: #e8eaf6; color: #283593; border-color: #9fa8da; }

  /* Hover just lifts/darkens the chip instead of resetting the per-type background. */
  .field-toolbar:not(.is-disabled) .field-chip:hover {
    filter: brightness(0.95);
    box-shadow: 0 2px 6px rgba(17, 12, 46, 0.12);
  }

  .field-chip i {
    font-size: 15px;
  }

  .field-chip-handle {
    color: inherit;
    opacity: 0.55;
    cursor: grab;
  }

  .field-toolbar-hint {
    margin-top: 4px;
    font-size: 11px;
    color: #9b98a6;
  }

  .config-section {
    margin-top: 20px;
    border-top: 1px solid #eee;
    padding-top: 16px;
  }

  .config-section-title {
    font-size: 13px;
    font-weight: 700;
    color: #2b2b33;
    margin-bottom: 10px;
  }

  .config-row {
    display: flex;
    gap: 12px;
  }

  .config-field {
    display: block;
    flex: 1;
    min-width: 0;
    font-size: 11px;
    font-weight: 700;
    color: #5b5870;
    margin-bottom: 12px;
  }

  .config-field-label {
    display: block;
    margin-bottom: 4px;
  }

  .config-field input,
  .config-field select {
    display: block;
    width: 100%;
    padding: 5px 8px;
    border: 1px solid #ddd6f0;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 400;
    color: #2b2b33;
    box-sizing: border-box;
    background: #fff;
  }

  /* A global reset (assets/css/main.css) forces border-color: transparent !important on focus
     app-wide; win it back for these two fields specifically. */
  .config-field input:focus,
  .config-field select:focus {
    border-color: var(--dx-primary) !important;
    outline: none;
  }

  /* .tf-field / .tf-field-editor / .tf-field-remove live in FIELD_CHIP_STYLES (component), not
     here - those spans bypass Angular's template renderer, so a rule here would never match
     them. See updateEditableCanvasStyles(). */

  .field-popup {
    position: fixed;
    z-index: 1000;
    width: 300px;
    max-height: min(480px, calc(100vh - 32px));
    overflow-y: auto;
    background: #fff;
    border: 1px solid #e2ddf0;
    border-radius: 10px;
    box-shadow: 0 10px 32px rgba(17, 12, 46, 0.2);
    padding: 14px;
    font-size: 13px;
  }

  .field-popup-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }

  .field-popup-title {
    font-size: 12px;
    font-weight: 700;
    color: #2b2b33;
  }

  .field-popup-delete {
    margin-left: auto;
    font-size: 17px;
    color: #b3261e;
    cursor: pointer;
    padding: 2px;
    border-radius: 4px;
  }

  .field-popup-delete:hover {
    background: #fdecea;
  }

  .field-popup label {
    display: block;
    font-size: 11px;
    font-weight: 700;
    color: #5b5870;
    margin-bottom: 10px;
  }

  .field-popup label input[type='text'],
  .field-popup label input:not([type]),
  .field-popup label input[type='number'] {
    display: block;
    width: 100%;
    margin-top: 4px;
    padding: 6px 8px;
    border: 1px solid #ddd6f0;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 400;
    color: #2b2b33;
    box-sizing: border-box;
  }

  .field-popup label input[type='checkbox'] {
    margin-left: 8px;
  }

  /* Same global focus border-reset as the Account ID field (assets/css/main.css) - win it back
     for every input in this popup. */
  .field-popup input:focus {
    border-color: var(--dx-primary) !important;
    outline: none;
  }

  .field-popup-advanced-toggle {
    width: 100%;
    text-align: left;
    background: none;
    border: none;
    padding: 6px 0;
    font-size: 12px;
    font-weight: 700;
    color: var(--dx-primary);
    cursor: pointer;
  }

  .field-popup-advanced {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #eee;
  }

  .field-popup-option-row {
    display: flex;
    gap: 6px;
    align-items: center;
    margin-bottom: 6px;
  }

  .field-popup-option-row input {
    flex: 1;
    padding: 5px 8px;
    border: 1px solid #ddd6f0;
    border-radius: 6px;
    font-size: 12px;
  }

  .field-popup-option-row i {
    cursor: pointer;
    color: #9b98a6;
    font-size: 16px;
  }

  .field-popup-option-row i:hover {
    color: #b3261e;
  }

  .field-popup-add-option {
    background: none;
    border: 1px dashed var(--dx-primary-border);
    color: var(--dx-primary);
    border-radius: 6px;
    padding: 5px 10px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
  }
</style>

<div class="docx-converter-page">
  <div class="docx-converter-shell">
    <div class="docx-panel preview-col">
      <div class="panel-header">
        <i class="bx bxs-file-doc"></i>
        <span>Document Preview</span>
        <span class="page-badge" *ngIf="pageCount && previewEngine === 'mammoth'">{{ pageCount }} page{{ pageCount === 1 ? '' : 's' }}</span>
        <div class="engine-toggle" *ngIf="previewDocument">
          <button type="button" class="engine-btn" [class.active]="previewEngine === 'mammoth'" (click)="setPreviewEngine('mammoth')">
            Mammoth (HTML-preview)
          </button>
          <button
            type="button"
            class="engine-btn"
            [class.active]="previewEngine === 'docx-preview'"
            [disabled]="isRenderingDocxPreview"
            (click)="setPreviewEngine('docx-preview')"
          >
            <i class="bx bx-loader-alt bx-spin" *ngIf="isRenderingDocxPreview"></i>
            {{ isRenderingDocxPreview ? 'Rendering...' : 'docx-preview (beta)' }}
          </button>
        </div>
      </div>
      <div class="preview-body">
        <ng-container *ngIf="previewEngine === 'mammoth'; else docxPreviewBlock">
          <div class="editable-canvas-wrap" *ngIf="previewDocument; else emptyPreview">
            <div
              #editableRoot
              class="editable-canvas"
              contenteditable="true"
              (input)="onCanvasInput()"
              (dragover)="onCanvasDragOver($event)"
              (drop)="onCanvasDrop($event)"
              (click)="onCanvasClick($event)"
            ></div>
          </div>
        </ng-container>
        <ng-template #docxPreviewBlock>
          <div *ngIf="docxPreviewError" class="empty-state">
            <i class="bx bx-error-circle"></i>
            <span>{{ docxPreviewError }}</span>
          </div>
          <iframe
            *ngIf="docxPreviewDocument && !docxPreviewError"
            class="preview-frame"
            [srcdoc]="docxPreviewDocument"
            title="Converted document preview (docx-preview)"
          ></iframe>
        </ng-template>
        <ng-template #emptyPreview>
          <div class="empty-state">
            <i class="bx bx-file-blank"></i>
            <span>Upload a .docx file to see the preview here</span>
          </div>
        </ng-template>
      </div>
      <div class="engine-note" *ngIf="previewEngine === 'docx-preview' && docxPreviewDurationMs !== null">
        <i class="bx bx-info-circle"></i>
        Rendered on the main thread in {{ docxPreviewDurationMs }}ms (UI was blocked for that duration). Experimental comparison only — the downloaded HTML still uses the Mammoth pipeline.
      </div>
    </div>

    <div class="docx-panel upload-col">
      <div class="panel-header">
        <i class="bx bx-upload"></i>
        <span>Docx to HTML Converter</span>
      </div>
      <div class="upload-body">
        <label class="upload-dropzone" [class.is-disabled]="isConverting" for="docxFileInput">
          <i class="bx bx-cloud-upload"></i>
          <span class="dropzone-text">{{ fileName || 'Click to choose a .docx file' }}</span>
          <span class="dropzone-hint" *ngIf="!fileName">.docx files only</span>
        </label>
        <input
          type="file"
          id="docxFileInput"
          class="visually-hidden"
          accept=".docx"
          [disabled]="isConverting"
          (change)="onFileSelected($event)"
        />

        <div *ngIf="uploadStatusMessage" class="alert-box alert-info">
          <i class="bx bx-check-circle"></i>
          <span>{{ uploadStatusMessage }}</span>
        </div>

        <div *ngIf="isConverting" class="loading-block">
          <i class="bx bx-loader-alt bx-spin loading-spinner"></i>
          <div class="loading-text">Converting {{ fileName }}...</div>
          <div class="progress-track">
            <div class="progress-fill" [style.width.%]="progressPercent"></div>
          </div>
          <div class="progress-percent">{{ progressPercent }}%</div>
        </div>

        <div *ngIf="errorMessage" class="alert-box alert-danger">
          <i class="bx bx-error-circle"></i>
          <span>{{ errorMessage }}</span>
        </div>

        <div *ngIf="warnings.length" class="alert-box alert-warning alert-collapsible">
          <div class="alert-collapsible-header" (click)="toggleWarnings()">
            <i class="bx bx-info-circle"></i>
            <span class="alert-title">Conversion warnings</span>
            <span class="alert-count-badge">{{ warnings.length }}</span>
            <i class="bx bx-chevron-down alert-chevron" [class.is-open]="warningsExpanded"></i>
          </div>
          <ul *ngIf="warningsExpanded">
            <li *ngFor="let warning of warnings">{{ warning }}</li>
          </ul>
        </div>

        <div class="field-toolbar" [class.is-disabled]="!fieldsEditingEnabled" *ngIf="fieldsEditingEnabled">
          <div class="field-toolbar-title">Fields</div>
          <div
            class="field-chip"
            *ngFor="let def of fieldTypeDefs"
            [attr.data-field-type]="def.type"
            draggable="true"
            (dragstart)="onToolbarDragStart($event, def)"
          >
            <i class="bx bx-grid-vertical field-chip-handle" title="Drag to place"></i>
            <i [class]="def.icon"></i>
            <span>{{ def.label }}</span>
          </div>
          <div class="field-toolbar-hint" *ngIf="!fieldsEditingEnabled">
            {{ previewDocument ? 'Switch to the Mammoth preview to drag fields into the document.' : 'Upload a document to add fields.' }}
          </div>
        </div>

        <div class="config-section" *ngIf="fieldsEditingEnabled">
          <div class="config-section-title">Configuration</div>
          <div class="config-row">
            <label class="config-field">
              <span class="config-field-label">Account ID</span>
              <input
                type="text"
                inputmode="numeric"
                placeholder="e.g. 1234"
                [ngModel]="accountId"
                (input)="onAccountIdInput($event)"
              />
            </label>
            <label class="config-field">
              <span class="config-field-label">Environment</span>
              <app-dropdown
                [options]="environmentOptions"
                [(ngModel)]="environment"
                placeholder="Select environment"
                [autoDisplayFirst]="false"
                [style]="{ width: '100%' }"
                appendTo="body"
                [sort]="false"
              ></app-dropdown>
            </label>
          </div>
        </div>

        <div class="action-row">
          <button type="button" class="btn-app btn-outline" (click)="reset()" [disabled]="isConverting">
            <i class="bx bx-reset"></i> Reset
          </button>
          <!--
          Download HTML disabled in favor of "Confirm Upload"; downloadHtml() itself is untouched
          in the component - restore by uncommenting this button.
          <button type="button" class="btn-app btn-primary" (click)="downloadHtml()" [disabled]="!previewDocument">
            <i class="bx bx-download"></i> Download HTML
          </button>
          -->
          <button type="button" class="btn-app btn-primary" (click)="confirmUpload()" [disabled]="!previewDocument">
            <i class="bx bx-cloud-upload"></i> Confirm Upload
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    #fieldPopup
    class="field-popup"
    *ngIf="selectedField as f"
    [style.top.px]="popupPosition?.top"
    [style.left.px]="popupPosition?.left"
    (click)="$event.stopPropagation()"
  >
    <div class="field-popup-header">
      <span class="field-popup-title">Field properties</span>
      <i class="bx bx-trash field-popup-delete" title="Delete field" (click)="removeField(f.id)"></i>
    </div>
    <label>
      Label
      <input type="text" [ngModel]="f.label" (ngModelChange)="updateField({ label: $event })" />
    </label>
    <label>
      Variable name / key
      <input type="text" [ngModel]="f.variableName" (ngModelChange)="updateField({ variableName: $event })" />
    </label>
    <label>
      Required
      <input type="checkbox" [ngModel]="f.required" (ngModelChange)="updateField({ required: $event })" />
    </label>
    <label>
      Placeholder text
      <input type="text" [ngModel]="f.placeholder" (ngModelChange)="updateField({ placeholder: $event })" />
    </label>

    <button type="button" class="field-popup-advanced-toggle" (click)="toggleAdvanced()">
      Advanced settings {{ advancedExpanded ? '▾' : '▸' }}
    </button>

    <div class="field-popup-advanced" *ngIf="advancedExpanded">
      <ng-container *ngIf="fieldSupportsMinMaxValue(f)">
        <label>
          Min value
          <input type="number" [ngModel]="f.minValue" (ngModelChange)="updateField({ minValue: $event })" />
        </label>
        <label>
          Max value
          <input type="number" [ngModel]="f.maxValue" (ngModelChange)="updateField({ maxValue: $event })" />
        </label>
      </ng-container>

      <ng-container *ngIf="fieldSupportsMinMaxLength(f)">
        <label>
          Min length
          <input type="number" [ngModel]="f.minLength" (ngModelChange)="updateField({ minLength: $event })" />
        </label>
        <label>
          Max length
          <input type="number" [ngModel]="f.maxLength" (ngModelChange)="updateField({ maxLength: $event })" />
        </label>
      </ng-container>

      <label>
        Default value
        <input type="text" [ngModel]="f.defaultValue" (ngModelChange)="updateField({ defaultValue: $event })" />
      </label>

      <label *ngIf="fieldSupportsPattern(f)">
        Validation pattern
        <input type="text" [ngModel]="f.validationPattern" (ngModelChange)="updateField({ validationPattern: $event })" />
      </label>

      <label *ngIf="fieldSupportsOptions(f)">
        Options list
        <div class="field-popup-option-row" *ngFor="let option of f.options; let i = index">
          <input type="text" [ngModel]="option" (ngModelChange)="updateOption(i, $event)" />
          <i class="bx bx-x" (click)="removeOption(i)"></i>
        </div>
        <button type="button" class="field-popup-add-option" (click)="addOption()">
          <i class="bx bx-plus"></i> Add option
        </button>
      </label>
    </div>
  </div>
</div>
